import { render, staticRenderFns } from "./SearchOverlay.vue?vue&type=template&id=0b361aeb&scoped=true&"
import script from "./SearchOverlay.vue?vue&type=script&lang=js&"
export * from "./SearchOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SearchOverlay.vue?vue&type=style&index=0&id=0b361aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b361aeb",
  null
  
)

export default component.exports